// Copyright (C) 2021 TANNER AG

import React from "react";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
    number: {
        color: "#e40045",
        minWidth: 60,
        display: "inline-block",
    },
});

const HeadingNumber = ({ classes, children }) => {
    return <span className={classes.number}>{children}</span>;
};

export default withStyles(styles)(HeadingNumber);



// WEBPACK FOOTER //
// ./src/emobility/HeadingNumber.js